import { createReducer } from 'reduxsauce'
import { Record } from 'immutable'
import { authTypes } from '.'

export const INITIAL_STATE = new Record({
	id: null,
	firstName: null,
	lastName: null,
	image: null,
	isActive: null,
	isVerified: null,
	role: null,
	email: null,
	theme: null,
	team: null,
	teams: [],
	token: null,
	updatedAt: null,
	createdAt: null,
})

export const putToken = (state, { token }) => state.merge({ token })
export const loginSuccess = (state, { profile }) => state.mergeDeep(profile)
export const logoutSuccess = () => new INITIAL_STATE()
export const createTeamSuccess = (state, { profile }) =>
	INITIAL_STATE().merge(profile)
export const switchTeamSuccess = (state, { profile }) =>
	INITIAL_STATE().merge(profile)

export const reducer = createReducer(INITIAL_STATE(), {
	[authTypes.PUT_TOKEN]: putToken,
	[authTypes.LOGIN_SUCCESS]: loginSuccess,
	[authTypes.LOGOUT_SUCCESS]: logoutSuccess,
	[authTypes.CREATE_TEAM_SUCCESS]: createTeamSuccess,
	[authTypes.SWITCH_TEAM_SUCCESS]: switchTeamSuccess,
})
